
import React from 'react'
import team1 from "../../assets/Frame 1321317770.png"

const AboutTeams = () => {
  return (
    <section className='mb-20'>
        <h2 className='font-semibold text-4xl text-[32px] text-[#414040] text-center'>Meet Our Amazing Team</h2>
        <p className='text-[#3D3939] text-base font-medium text-center mt-3 mb-5 md:hidden'>With lots of unique blocks, you can easily build a page without coding. Build your next landing page.</p>
        <p className='text-[#4E4949] font-normal text-base md:text-[15px] hidden md:block text-center mt-2 mb-9'>
        Dont let go of the opportunity to view our services

        </p>
        <section className='flex md:flex-col md:w-[90%] w-[80%] mx-auto justify-between'>
        <div>
            <img src={team1} alt="team one" />
            <div className='md:mb-10'>
                <h2 className='text-2xl text-[#373535] font-medium my-3'>Adeyanyuola Tobilola</h2>
                <p className='text-[15px] font-normal text-[#373535]'>Co-Founder </p>
            </div>
        </div>
        <div>
            <img src={team1} alt="team one" />
            <div className='md:mb-10'>
                <h2 className='text-2xl text-[#373535] font-medium my-3'>Adeyanyuola Tobilola</h2>
                <p className='text-[15px] font-normal text-[#373535]'>Co-Founder </p>
            </div>
        </div>
        <div>
            <img src={team1} alt="team one" />
            <div>
                <h2 className='text-2xl text-[#373535] font-medium my-3'>Adeyanyuola Tobilola</h2>
                <p className='text-[15px] font-normal text-[#373535]'>Co-Founder </p>
            </div>
        </div>
        </section>
    </section>
  )
}

export default AboutTeams